module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjQsIDE0NCwgMjU1LCAxKSI+CiAgICA8cGF0aCBkPSJNMzggNkgxMGMtMi4yMSAwLTQgMS43OS00IDR2MjhjMCAyLjIxIDEuNzkgNCA0IDRoMjhjMi4yMSAwIDQtMS43OSA0LTRWMTBjMC0yLjIxLTEuNzktNC00LTR6TTE4IDM0aC00VjIwaDR2MTR6bTggMGgtNFYxNGg0djIwem04IDBoLTR2LThoNHY4eiI+PC9wYXRoPgogICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIgZmlsbD0ibm9uZSI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/views/PotentialSafetyHazard/img/plaint.svg
// module id = wOdk
// module chunks = 3